/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pre-op-addl-assessment.reducer';

export const PreOpAddlAssessment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const preOpAddlAssessmentList = useAppSelector(state => state.preOpAddlAssessment.entities);
  const loading = useAppSelector(state => state.preOpAddlAssessment.loading);
  const totalItems = useAppSelector(state => state.preOpAddlAssessment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pre-op-addl-assessment-heading" data-cy="PreOpAddlAssessmentHeading">
        <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.home.title">Pre Op Addl Assessments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pre-op-addl-assessment/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.home.createLabel">Create new Pre Op Addl Assessment</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.preOpAddlAssessment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {preOpAddlAssessmentList && preOpAddlAssessmentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('history')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.history">History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('history')} />
                </th>
                <th className="hand" onClick={sort('clinicalFindings')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.clinicalFindings">Clinical Findings</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('clinicalFindings')} />
                </th>
                <th className="hand" onClick={sort('specificInvestigations')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.specificInvestigations">Specific Investigations</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('specificInvestigations')} />
                </th>
                <th className="hand" onClick={sort('medicalAssessment')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalAssessment">Medical Assessment</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicalAssessment')} />
                </th>
                <th className="hand" onClick={sort('medicalAssessmentNotes')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalAssessmentNotes">Medical Assessment Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicalAssessmentNotes')} />
                </th>
                <th className="hand" onClick={sort('medicalCondition')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalCondition">Medical Condition</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicalCondition')} />
                </th>
                <th className="hand" onClick={sort('medicalConditionNotes')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.medicalConditionNotes">Medical Condition Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicalConditionNotes')} />
                </th>
                <th className="hand" onClick={sort('instructions')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.instructions">Instructions</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('instructions')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.reviewedBy">Reviewed By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {preOpAddlAssessmentList.map((preOpAddlAssessment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pre-op-addl-assessment/${preOpAddlAssessment.id}`} color="link" size="sm">
                      {preOpAddlAssessment.id}
                    </Button>
                  </td>
                  <td>{preOpAddlAssessment.history}</td>
                  <td>{preOpAddlAssessment.clinicalFindings}</td>
                  <td>{preOpAddlAssessment.specificInvestigations}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.MedicalAssessMent.${preOpAddlAssessment.medicalAssessment}`} />
                  </td>
                  <td>{preOpAddlAssessment.medicalAssessmentNotes}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.MedicalCondition.${preOpAddlAssessment.medicalCondition}`} />
                  </td>
                  <td>{preOpAddlAssessment.medicalConditionNotes}</td>
                  <td>{preOpAddlAssessment.instructions}</td>
                  <td>{preOpAddlAssessment.active ? 'true' : 'false'}</td>
                  <td>{preOpAddlAssessment.cursor}</td>
                  <td>{preOpAddlAssessment.lastupdated}</td>
                  <td>{preOpAddlAssessment.microSec}</td>
                  <td>{preOpAddlAssessment.timestampentry}</td>
                  <td>
                    {preOpAddlAssessment.surgery ? (
                      <Link to={`/patient-procedure/${preOpAddlAssessment.surgery.id}`}>{preOpAddlAssessment.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {preOpAddlAssessment.reviewedBy ? (
                      <Link to={`/doctor/${preOpAddlAssessment.reviewedBy.id}`}>{preOpAddlAssessment.reviewedBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pre-op-addl-assessment/${preOpAddlAssessment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pre-op-addl-assessment/${preOpAddlAssessment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pre-op-addl-assessment/${preOpAddlAssessment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.home.notFound">No Pre Op Addl Assessments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={preOpAddlAssessmentList && preOpAddlAssessmentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PreOpAddlAssessment;
